import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumDsEmbedded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-medium-ds-embedded_svg__Layer_1"
    x={0}
    y={0}
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".spaces-medium-ds-embedded_svg__st0{fill:#676767}"}</style>
    <g id="spaces-medium-ds-embedded_svg__DS_bracket">
      <path
        className="spaces-medium-ds-embedded_svg__st0"
        d="m13.7 19.8-2.5-2.5c-.2-.2-.1-.6 0-.8l2.5-2.5c.2-.2.5-.2.7 0s.2.5 0 .7l-2.1 2.2 2.1 2.1c.2.2.2.5 0 .7-.2.2-.5.2-.7.1zM19.8 19.9c-.2-.2-.2-.6 0-.8l2-2.1-2.1-2.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.5 2.5c.2.2.2.5.1.6l-2.5 2.5c-.2.2-.6.2-.7.1zM15.3 19.8c-.2-.1-.3-.4-.1-.7l3-5c.1-.2.5-.3.7-.2s.3.4.2.7l-3 5c-.2.2-.6.3-.8.2z"
      />
    </g>
    <path
      className="spaces-medium-ds-embedded_svg__st0"
      d="M18 7c0-1.7-2.7-3-6-3S6 5.3 6 7v11.4c0 1.4 2.7 2.6 6 2.6v-1c-3.2 0-5-1.1-5-1.6V8.6c1.1.8 2.9 1.4 5 1.4s3.9-.5 5-1.3V13h1V7zm-6 2C8.9 9 7 7.8 7 7s1.9-2 5-2 5 1.2 5 2-1.9 2-5 2z"
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumDsEmbedded);
export default Memo;
